import * as React from 'react';
import { ReactNode } from 'react';
import { useParams } from 'react-router';
import { ErrorComponent } from '../components/Error';

export const ErrorPage = (): ReactNode => {
  const params = useParams();
  return (<ErrorComponent code={parseInt(params.code, 10) || 500}/>);
};

export default ErrorPage;
